export default "__VITE_ASSET__BRLlC$SU__"